import { create } from 'zustand';
import type { Room, RoomWithDetails } from '@matchroom/shared';

interface RoomStoreState {
  rooms: Room[];
  currentRoom: RoomWithDetails | null;
  filters: {
    search: string;
    visibility: string;
    roomStatus: string;
    sort: 'newest' | 'participants';
  };
  isLoading: boolean;
  setRooms: (rooms: Room[]) => void;
  setCurrentRoom: (room: RoomWithDetails | null) => void;
  updateCurrentRoom: (room: RoomWithDetails) => void;
  setFilters: (filters: Partial<RoomStoreState['filters']>) => void;
  setLoading: (loading: boolean) => void;
  clear: () => void;
}

export const useRoomStore = create<RoomStoreState>((set) => ({
  rooms: [],
  currentRoom: null,
  filters: { search: '', visibility: '', roomStatus: '', sort: 'newest' },
  isLoading: false,
  setRooms: (rooms) => set({ rooms }),
  setCurrentRoom: (room) => set({ currentRoom: room }),
  updateCurrentRoom: (room) => set({ currentRoom: room }),
  setFilters: (filters) => set((s) => ({ filters: { ...s.filters, ...filters } })),
  setLoading: (isLoading) => set({ isLoading }),
  clear: () => set({ rooms: [], currentRoom: null, isLoading: false }),
}));
